// Module
var code = " <button class=\"btn btn-secondary btn-hollow btn-sm\" ng-click=\"$ctrl.openModal()\"> {{ 'STUDY_PLAN_CREATE_NEW' | translate }} </button> ";
// Exports
module.exports = code;